import { Injectable } from '@angular/core';
import { DynamicComponentService } from '../dynamic_components/dynamic.service';
import { EpgWindowComponent } from './epg_window.component';
import { Channel } from '../IPTV_Editor/iptv_editor.component';
import { Ajax } from 'src/app/services/ajax.service';
import { EPG_list, EPG_Bundle } from './epg.interfaces';

@Injectable({providedIn: 'root'})
export class EpgWindowService {
    /**
     * Объект с данными для выводимого в окне списка каналов
     */
    private EPG_Bundle:EPG_Bundle = {epg:[], played_programm: null};
    private _channel:Channel = null;
    constructor(private _DCservice:DynamicComponentService, private _ajax:Ajax) { }
    /**
     * Показать программу передач
     * @param channel
     */
    show(channel?:Channel){
        // Если указан другой канал, тогда загружаем EPG с сервера.
        if(channel != this._channel){
            this._channel = channel;
            this.EPG_Bundle.epg = [];
            this.EPG_Bundle.played_programm = null;

            const query:any = {op:"get_epg_day", "timezone":((new Date()).getTimezoneOffset()/60*-1).toString()};
            if(this._channel.tvg_id){
                query.channel_id = this._channel.tvg_id;
            } else {
                query.channel_name = this._channel.name;
            }
            this._ajax.send(query).subscribe(data=>{
                if(data.epg){
                    this.EPG_Bundle.epg = this.update_epg(data.epg);
                } else {
                    this.EPG_Bundle.epg = this.get_empty_epg();
                }
            },()=>{
                this.EPG_Bundle.epg = this.get_empty_epg();
            },()=>{
                this.init_component();
            });
        } else {
            this.init_component();
        }
    }
    /**
     * Открывает окно программы передач.
     */
    private init_component(){
        this.acualize_epg_list();
        const instance = this._DCservice.attach(EpgWindowComponent);
        instance.EPG_Bundle = this.EPG_Bundle;
        instance.channel = this._channel;
        instance.title = this._channel ? this._channel.name : "Канал";
        // Подписываемся на загрузку предыдущей программы передач
        instance.$load_prev.subscribe(()=>{
            this.load_prev_epg();
        });
        
        // Делает прокрутку до текущей программы или программы воспроизводимой из архива
        setTimeout(() => {
            let el = document.querySelector("epg-window li.played");
            if(!el){
                el = document.querySelector("epg-window li.current");
            }
            if(el){
                el.scrollIntoView({block: "start", behavior: "smooth"});
            }
        }, 100);
    }
    /**
     * Загрузка истории предыдущего EPG
     */
    private load_prev_epg(){
        const query:any = {op:"get_epg_day", beforeTime:this.EPG_Bundle.epg[0].start, "timezone":((new Date()).getTimezoneOffset()/60*-1).toString()};
        if(this._channel.tvg_id){
            query.channel_id = this._channel.tvg_id;
        } else {
            query.channel_name = this._channel.name;
        }
        this._ajax.send(query).subscribe(data=>{
            if(data.epg){
                data.epg.forEach((epg:EPG_list) => {
                    epg.chronology = "prev";
                });
                this.EPG_Bundle.epg = this.update_epg(data.epg.concat(this.EPG_Bundle.epg));
            } else {
                this.EPG_Bundle.epg = this.get_empty_epg(this.EPG_Bundle.epg[0].start).concat(this.EPG_Bundle.epg);
            }
        });
    }
    /**
     * Обновление списка программы передач. Выставление окончание программы из начала следующей программы.
     * С источника EPG начало программы может не совпадать концом предыдущей, поэтому необходимо унифицировать данный факт.
     * @param EPG Изменяется сам объект, а не его копия.
     */
    private update_epg(EPG:EPG_list[]):EPG_list[]{
        EPG.forEach((item, index) => {
            item.start = Math.floor(item.start);
            item.stop = EPG[index+1] ? Math.floor(EPG[index+1].start) : Math.floor(Date.now()/1000) + 60*60;
        });
        return EPG;
    }
    /**
     * Следующая программа передач
     * @param epg 
     */
    public get_next_epg(epg:EPG_list, channel:Channel){
        let next_epg:EPG_list = null;
        const start = epg.start;
        if(this._channel == channel) {
            this.EPG_Bundle.epg.findIndex((item, index)=>{
                if(item.start > start){
                    next_epg = item;
                    return true;
                }
            });
        }
        if(!next_epg){
            channel.epg.findIndex((item)=>{
                if(item.start > epg.start){
                    next_epg = Object.assign({},item);
                    return true;
                }
            });
        }
        if(!next_epg){
            next_epg = {start: epg.stop, stop: (60 * 60) + Math.floor(epg.stop), programm: "Нет телепрограммы", progress: 0};
        }
        return next_epg;
    }
    /**
     * Установка текущей проигрываемой программы.
     * @param epg 
     */
    set_played_programm(epg:EPG_list){
        this.EPG_Bundle.played_programm = epg;
    }
    /**
     * Актуализируем список EPG Выставляем текущую передачу и прогресс.
     */
    acualize_epg_list() {
        const now = (Date.now()/1000);
        this.EPG_Bundle.epg.findIndex((epg, i)=>{
            if(!this.EPG_Bundle.epg[i+1] && epg.stop < now){
                epg.stop = now + 60*60;
            }
            if(epg.stop < now) {
                epg.chronology = "prev";
            } else if(epg.start <= now && epg.stop >= now) {
                epg.chronology = "current";
                if(!this.EPG_Bundle.played_programm || this.EPG_Bundle.played_programm != epg){
                    epg.progress = ((now - epg.start)/(epg.stop - epg.start))*100;
                }
            } else {
                epg.chronology = "next";
            }
        });
    }
    /**
     * Пустой список программы передач на день
     * @param timeBefore Время Unix до которого нужно составить программу передач
     */
    private get_empty_epg(timeBefore?:number):EPG_list[] {
        const date = new Date(),
        current_date = date.getTime(),
        epg:EPG_list[] = [];
        let n = 29;
        if(timeBefore){
            date.setTime(timeBefore*1000);
            date.setHours(date.getHours()-1, 0,0,0);
            n = date.getHours() + 4;
        }
        date.setHours(-4,0,0,0);
        let start:number = Math.floor(date.getTime()/1000);
        for (let i = 1; i <= n; i++) {
            let stop = start + 1*60*60,
                chronology:'prev'|'current'|'next' = "next";
            if(start <= current_date && stop < current_date){
                chronology = "prev";
            } else if(start <= current_date && stop >= current_date) {
                chronology = "current";
            }
            epg.push({start: start, stop: stop, programm: "Нет телепередачи", chronology: chronology});
            start = stop;
        }
        return epg;
    }
    /**
     * Пустая программа передач на текущий момент.
     */
    public get_empty_epg_current():EPG_list{
        const date = new Date();
        date.setMinutes(0,0,0);
        const start = Math.floor(date.getTime()/1000);
        date.setMinutes(60);
        const stop = Math.floor(date.getTime()/1000);
        const progress = Math.floor((((Date.now()/1000)-start)/(stop-start))*100);
        return {start: start, stop: stop, programm: "Нет телепередачи", progress: progress, chronology: "current"};
    }
}